import {
    Button,
    CloseButton,
    Dialog,
    Field,
    Flex,
    Grid,
    GridItem,
    Input,
    Link,
    Select,
    Text,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { toaster } from "@/components/ui/toaster";
import { timeOptionsCollection } from "@/utilities/helpers/timeOptions";

const FormModal = ({
    isOpen,
    onClose,
    origin,
    developmentName,
    date,
    setDate,
    time,
    setTime,
    formIds,
    wiggot_props,
}) => {
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");

    const router = useRouter();

    const openNewTab = (url) => {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.click(); // Simula el click del enlace;
    };

    const postForm = () => {
        let data_send = {
            fields: [
                {
                    name: "firstname",
                    value: name,
                },
                {
                    name: "lastname",
                    value: lastName,
                },
                {
                    name: "email",
                    value: email,
                },
                {
                    name: "phone",
                    value: phone,
                },
                {
                    name: "develop",
                    value: developmentName,
                },
                {
                    name: "he_leido_y_acepto_el_aviso_de_privacidad",
                    value: true,
                },
                ...(origin !== "whatsapp" && origin !== "adviser_contact"
                    ? [
                          {
                              name: "date",
                              value: date,
                          },
                          {
                              name: "time",
                              value: time,
                          },
                      ]
                    : []),
            ],
            context: {
                ipAddress: "3.14.97.137",
                pageUri: "www.grupoguia.mx",
                pageName: `Grupo Guia | ${developmentName || ""}`,
            },
        };
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data_send),
        };
        if (origin === "whatsapp") {
            fetch(
                `https://api.hsforms.com/submissions/v3/integration/submit/5930840/${formIds?.form_whatsApp || "0d8602b1-6da3-42ac-b0b6-02f777815149"}`, //Aqui puse el ID General de quiero que me contate un asesor (No se brindo un general de Whatsapp)
                requestOptions
            )
                .then((res) => res.json())
                .then((data) => {
                    if (!data.redirectUri) {
                        throw new Error("Error en el envío del formulario");
                    }

                    toaster.create({
                        title: "¡Tus datos fueron enviados correctamente!",
                        type: "success",
                        duration: 4000,
                        closable: true,
                    });

                    setName("");
                    setLastName("");
                    setEmail("");
                    setPhone("");
                    onClose();
                    router.push(
                        `/desarrollos/thankyoupage-contactar-whatsapp/${wiggot_props?.whatsapp ? wiggot_props?.whatsapp : wiggot_props?.contact_phone}`
                    );
                    openNewTab(
                        `https://api.whatsapp.com/send?phone=${wiggot_props?.whatsapp ? wiggot_props?.whatsapp : wiggot_props?.contact_phone}&text=${`Hola mi nombre es ${name} ${lastName}, me gustaría saber mas sobre ${developmentName}`}`
                    );
                })
                .catch((error) => {
                    toaster.create({
                        title: "Hubo un problema al enviar tus datos.",
                        description: error.message,
                        type: "error",
                        duration: 4000,
                        closable: true,
                    });
                });
        } else if (origin === "adviser_contact") {
            fetch(
                `https://api.hsforms.com/submissions/v3/integration/submit/5930840/${formIds?.form_orientation || "0d8602b1-6da3-42ac-b0b6-02f777815149"}`,
                requestOptions
            )
                .then((res) => res.json())
                .then((data) => {
                    if (!data.redirectUri) {
                        throw new Error("Error en el envío del formulario");
                    }

                    toaster.create({
                        title: "¡Tus datos fueron enviados correctamente!",
                        type: "success",
                        duration: 4000,
                        closable: true,
                    });

                    setName("");
                    setLastName("");
                    setEmail("");
                    setPhone("");
                    onClose();
                    openNewTab("https://grupoguia.mx/desarrollos/thankyoupage-contacto-gracias");
                })
                .catch((error) => {
                    toaster.create({
                        title: "Hubo un problema al enviar tus datos.",
                        description: error.message,
                        type: "error",
                        duration: 4000,
                        closable: true,
                    });
                });
        } else {
            fetch(
                `https://api.hsforms.com/submissions/v3/integration/submit/5930840/${formIds?.form_contact || "3dd98b01-f560-4fc7-8bfd-9f890e9ad26b"}`,
                requestOptions
            )
                .then((res) => res.json())
                .then((data) => {
                    if (!data.redirectUri) {
                        throw new Error("Error en el envío del formulario");
                    }

                    toaster.create({
                        title: "¡Tus datos fueron enviados correctamente!",
                        type: "success",
                        duration: 4000,
                        closable: true,
                    });

                    setName("");
                    setLastName("");
                    setEmail("");
                    setPhone("");
                    onClose();
                    openNewTab("https://grupoguia.mx/desarrollos/thankyoupage-contacto-gracias");
                })
                .catch((error) => {
                    toaster.create({
                        title: "Hubo un problema al enviar tus datos.",
                        description: error.message,
                        type: "error",
                        duration: 4000,
                        closable: true,
                    });
                });
        }
    };

    return (
        <Dialog.Root
            open={isOpen}
            onOpenChange={() => onClose()}
            preventScroll
            placement="center"
            size={{ base: "sm", md: "md" }}
        >
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content p={{ base: 2, md: 10 }} color="black">
                    <Dialog.Header fontWeight="bold" fontSize="xl" color="#2D2D2D">
                        <Dialog.Title>Contacto</Dialog.Title>
                    </Dialog.Header>
                    <Dialog.Description mb={6}>
                        <Text fontSize="md" fontWeight={400} color="#545454" mt={5}>
                            {origin !== "adviser_contact"
                                ? `Compártenos tus datos y descubre más sobre ${developmentName
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                          (word) =>
                                              word.charAt(0).toLocaleUpperCase("es-ES") +
                                              word.slice(1)
                                      )
                                      .join(" ")}.`
                                : "Recibe atención personalizada por un asesor"}
                        </Text>
                    </Dialog.Description>
                    <Dialog.CloseTrigger asChild>
                        <CloseButton size="md" borderRadius="md" />
                    </Dialog.CloseTrigger>
                    <Dialog.Body>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                postForm();
                            }}
                        >
                            <Grid templateColumns="repeat(2, 1fr)" gap={10}>
                                <GridItem colSpan={2}>
                                    <Field.Root required>
                                        <Field.Label fontSize="sm">
                                            Nombre/s <Field.RequiredIndicator />
                                        </Field.Label>
                                        <Input
                                            variant="flushed"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            mt={4}
                                            _focus={{
                                                boxShadow: "none",
                                                borderColor: "blue.600",
                                            }}
                                        />
                                    </Field.Root>
                                </GridItem>
                                <GridItem colSpan={2}>
                                    <Field.Root required>
                                        <Field.Label fontSize="sm">
                                            Apellidos <Field.RequiredIndicator />
                                        </Field.Label>
                                        <Input
                                            variant="flushed"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            mt={4}
                                            _focus={{
                                                boxShadow: "none",
                                                borderColor: "blue.600",
                                            }}
                                        />
                                    </Field.Root>
                                </GridItem>
                                <GridItem colSpan={{ base: 2, md: 1 }}>
                                    <Field.Root required>
                                        <Field.Label fontSize="sm">
                                            Número de teléfono <Field.RequiredIndicator />
                                        </Field.Label>
                                        <Input
                                            variant="flushed"
                                            type="number"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            mt={4}
                                            _focus={{
                                                boxShadow: "none",
                                                borderColor: "blue.600",
                                            }}
                                        />
                                    </Field.Root>
                                </GridItem>
                                <GridItem colSpan={{ base: 2, md: 1 }}>
                                    <Field.Root required>
                                        <Field.Label fontSize="sm">
                                            Correo <Field.RequiredIndicator />
                                        </Field.Label>
                                        <Input
                                            variant="flushed"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            mt={4}
                                            _focus={{
                                                boxShadow: "none",
                                                borderColor: "blue.600",
                                            }}
                                        />
                                    </Field.Root>
                                </GridItem>
                                {origin !== "whatsapp" && origin !== "adviser_contact" && (
                                    <>
                                        <GridItem colSpan={{ base: 2, md: 1 }}>
                                            <Field.Root required>
                                                <Field.Label fontSize="sm">
                                                    Fecha <Field.RequiredIndicator />
                                                </Field.Label>
                                                <Input
                                                    variant="flushed"
                                                    type="date"
                                                    value={date}
                                                    onChange={(e) => setDate(e.target.value)}
                                                    mt={4}
                                                    _focus={{
                                                        boxShadow: "none",
                                                        borderColor: "blue.600",
                                                    }}
                                                />
                                            </Field.Root>
                                        </GridItem>
                                        <GridItem colSpan={{ base: 2, md: 1 }}>
                                            <Field.Root required>
                                                <Field.Label fontSize="sm">
                                                    Hora <Field.RequiredIndicator />
                                                </Field.Label>
                                                <Select.Root
                                                    collection={timeOptionsCollection}
                                                    value={time ? [time] : ["08:00"]}
                                                    onValueChange={(details) => {
                                                        setTime(details.value[0]);
                                                    }}
                                                    size="sm"
                                                    mt={4}
                                                    style={{ textAlign: "center", border: "none" }}
                                                >
                                                    <Select.Control>
                                                        <Select.Trigger pl={4} borderWidth={0}>
                                                            <Select.ValueText
                                                                placeholder="Hora"
                                                                overflowWrap="break-word"
                                                                whiteSpace="normal"
                                                                color="gray.600"
                                                            />
                                                        </Select.Trigger>
                                                        <Select.IndicatorGroup pr={4}>
                                                            <Select.Indicator />
                                                        </Select.IndicatorGroup>
                                                    </Select.Control>
                                                    <Select.Positioner>
                                                        <Select.Content p={2}>
                                                            {timeOptionsCollection.items.map(
                                                                (option) => (
                                                                    <Select.Item
                                                                        item={option}
                                                                        key={option.value}
                                                                        p={1}
                                                                        color="gray.600"
                                                                    >
                                                                        {option.label}
                                                                        <Select.ItemIndicator />
                                                                    </Select.Item>
                                                                )
                                                            )}
                                                        </Select.Content>
                                                    </Select.Positioner>
                                                </Select.Root>
                                            </Field.Root>
                                        </GridItem>
                                    </>
                                )}
                                <GridItem colSpan={2}>
                                    <Flex>
                                        <Checkbox mr={2} required colorPalette="blue" />
                                        <Text color="accent.500">
                                            He leído y acepto el
                                            <Link
                                                href="https://grupoguia.mx/Aviso-de-privacidad"
                                                color="blue"
                                                textDecoration="underline"
                                                ml={2}
                                                external
                                            >
                                                Aviso de privacidad
                                            </Link>
                                        </Text>
                                    </Flex>
                                </GridItem>
                                <GridItem colSpan={2} textAlign="center">
                                    <Button
                                        minW="20vw"
                                        type="submit"
                                        bg="#FECB2E"
                                        borderRadius="sm"
                                        color="black"
                                        _hover={{ bg: "#E0A800" }}
                                    >
                                        {origin === "whatsapp" ? "Envía whatsapp" : "Enviar"}
                                    </Button>
                                </GridItem>
                            </Grid>
                        </form>
                    </Dialog.Body>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    );
};

export default FormModal;
